<template>
  <v-app class="container" style="max-width: 1400px; margin: 0 auto">
    <!-- Cabeçalho -->
    <Header />
    <!-- Conteúdo principal -->
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Header from "@/components/Header.vue";

export default {
  name: "App",
  components: {
    Header
  },
  beforeCreate() {
    if (localStorage.getItem("pwK")) {
      if (!this.$store.state.usuario.id) {
        this.$store.dispatch("getUsuario");
        this.$store.dispatch("getSite");
      }
    } else {
      this.$store.dispatch("getSite");
    }
  },
  data: () => ({}),
  props: {
    source: String
  }
};
</script>
